<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyTabLinks />
                    <SurveyUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @success="$router.push(`/surveys`)"
                        @deleted="$router.push(`/surveys`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import SurveyTabLinks from '@/components/surveys/SurveyTabLinks';
    import SurveyUpsertForm from '@/components/surveys/SurveyUpsertForm';

    export default {
        name: 'SurveyEdit',

        components: {
            SurveyTabLinks,
            SurveyUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/surveys/${id}`)).data;
            },
        },
    };
</script>
